import React from "react";
import MasterDataPage from "@/components/MasterDataPage";
import { Building2 } from "lucide-react";

export default function MasterBodyShops() {
  return (
    <MasterDataPage
      title="Body Shops"
      subtitle="Network of partner body shops — commissions, tokens, KPIs"
      entity="body-shops"
      testId="bodyshops"
      icon={Building2}
      detailRoute={(r) => `/master/body-shops/${r.id}`}
      defaultForm={{
        company_name: "", owner_name: "", phone: "", email: "", address: "",
        city: "", state: "", zip_code: "", commission_pct: 15.0, payment_terms: "Net 15", notes: "",
      }}
      fields={[
        { key: "company_name", label: "Company Name", required: true, span: 2 },
        { key: "owner_name", label: "Owner Name" },
        { key: "phone", label: "Phone" },
        { key: "email", label: "Email", type: "email", span: 2 },
        { key: "address", label: "Address", span: 2 },
        { key: "city", label: "City" },
        { key: "state", label: "State" },
        { key: "zip_code", label: "ZIP" },
        { key: "commission_pct", label: "Commission %", type: "number", required: true },
        { key: "payment_terms", label: "Payment Terms", type: "select", options: ["Net 15", "Net 30", "Net 45", "Net 60", "On Receipt"] },
        { key: "notes", label: "Notes", type: "textarea", span: 2 },
      ]}
      columns={[
        { key: "company_name", label: "Shop" },
        { key: "owner_name", label: "Owner" },
        { key: "city", label: "Location", render: (r) => [r.city, r.state].filter(Boolean).join(", ") || "—" },
        { key: "commission_pct", label: "Commission", render: (r) => `${r.commission_pct}%` },
        { key: "jobs_count", label: "Jobs" },
        { key: "commission_total", label: "Commission $", render: (r) => `$${(r.commission_total || 0).toLocaleString()}` },
      ]}
    />
  );
}
